import React, { useState, useEffect, useRef } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import GoogleLoginButton from './GoogleLoginButton';

const Navigation = () => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);
  const [isMusicOpen, setIsMusicOpen] = useState(false);
  const musicDropdownRef = useRef(null);
  const location = useLocation();

  const handleNavCollapse = () => setIsNavCollapsed(!isNavCollapsed);

  const closeNav = () => {
    setIsNavCollapsed(true);
    setIsMusicOpen(false);
  };

  const isMusicActive =
    location.pathname.startsWith('/music') ||
    location.pathname === '/albums-of-the-year';

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (musicDropdownRef.current && !musicDropdownRef.current.contains(event.target)) {
        setIsMusicOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  // Close menus on route change
  useEffect(() => {
    setIsMusicOpen(false);
    setIsNavCollapsed(true);
  }, [location.pathname]);

  const navLinks = [
    { path: '/title', text: 'Home', isExternal: false },
    { path: '/blog', text: 'Blog', isExternal: false },
    { path: 'http://codefad.co.uk', text: 'Codefad', isExternal: true },
    {
      text: 'Music',
      isDropdown: true,
      children: [
        { path: '/music', text: 'My Music', end: true },
        { path: '/music/albums-of-the-year', text: 'Albums of the Year', end: false }
      ]
    },
    { path: '/photos', text: 'Photos', isExternal: false },
    { path: '/utils', text: 'Utils', isExternal: false }
  ];

  return (
    <nav className="navbar navbar-inverse navbar-fixed-top">
      <div className="container">
        <div className="navbar-header page-scroll">
          <button
            type="button"
            className="navbar-toggle"
            data-toggle="collapse"
            data-target="#bs-example-navbar-collapse-1"
            onClick={handleNavCollapse}
          >
            <span className="sr-only">Toggle navigation</span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
            <span className="icon-bar"></span>
          </button>
          <Link className="navbar-brand" to="/title" onClick={closeNav}>
            <span>-</span> Phil Withey <span>-</span>
          </Link>
        </div>

        <div className={`collapse navbar-collapse ${!isNavCollapsed ? 'in' : ''}`} id="bs-example-navbar-collapse-1">
          <ul className="nav navbar-nav navbar-right">
            <li className="hidden">
              <a href="#page-top" aria-label="Page top">Page top</a>
            </li>
            {navLinks.map((link, index) => {
              if (link.isDropdown) {
                return (
                  <li
                    key={index}
                    ref={musicDropdownRef}
                    className={`page-scroll dropdown ${isMusicOpen ? 'open' : ''} ${isMusicActive ? 'active' : ''}`}
                    onMouseEnter={() => setIsMusicOpen(true)}
                    onMouseLeave={() => setIsMusicOpen(false)}
                  >
                    <a
                      href="#music"
                      className={`dropdown-toggle ${isMusicActive ? 'active' : ''}`}
                      onClick={(e) => {
                        e.preventDefault();
                        setIsMusicOpen(!isMusicOpen);
                      }}
                      role="button"
                      aria-haspopup="true"
                      aria-expanded={isMusicOpen}
                    >
                      {link.text} <span className="caret"></span>
                    </a>
                    <ul className="dropdown-menu nav-dropdown-menu">
                      {link.children.map((child, childIndex) => (
                        <li key={childIndex}>
                          <NavLink
                            to={child.path}
                            end={child.end}
                            className={({ isActive }) => (isActive ? 'active' : '')}
                            onClick={closeNav}
                          >
                            {child.text}
                          </NavLink>
                        </li>
                      ))}
                    </ul>
                  </li>
                );
              }

              return (
                <li key={index} className="page-scroll">
                  {link.isExternal ? (
                    <>
                      <a className="hidden-xs" href={link.path} target="_blank" rel="noopener noreferrer">
                        {link.text}
                      </a>
                      <a
                        className="visible-xs"
                        data-toggle="collapse"
                        data-target=".navbar-collapse"
                        href={link.path}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={closeNav}
                      >
                        {link.text}
                      </a>
                    </>
                  ) : (
                    <>
                      <NavLink
                        className={({ isActive }) => `hidden-xs${isActive ? ' active' : ''}`}
                        to={link.path}
                        end={link.path === '/title'}
                        onClick={closeNav}
                      >
                        {link.text}
                      </NavLink>
                      <NavLink
                        className={({ isActive }) => `visible-xs${isActive ? ' active' : ''}`}
                        data-toggle="collapse"
                        data-target=".navbar-collapse"
                        to={link.path}
                        end={link.path === '/title'}
                        onClick={closeNav}
                      >
                        {link.text}
                      </NavLink>
                    </>
                  )}
                </li>
              );
            })}
            <li className="page-scroll">
              <NavLink
                to="/map"
                className={({ isActive }) => (isActive ? 'active' : '')}
                onClick={closeNav}
              >
                Map
              </NavLink>
            </li>
            <GoogleLoginButton />
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
